import { render, staticRenderFns } from "./append.vue?vue&type=template&id=b2c9d68c&scoped=true&"
import script from "./append.vue?vue&type=script&lang=js&"
export * from "./append.vue?vue&type=script&lang=js&"
import style0 from "./append.vue?vue&type=style&index=0&id=b2c9d68c&lang=scss&scoped=true&"
import style1 from "./append.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c9d68c",
  null
  
)

export default component.exports